module.exports = __webpack_public_path__ + "media/images/country_flags/tn-3898ca4e732c4d305819b5cef1f6cec7.png";